/**
 * @generated SignedSource<<31155af16674156088144968ba4780e9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SavedViewUpdatesAsideQuery$variables = {
  viewUuid: string;
  workspaceUuid: string;
};
export type SavedViewUpdatesAsideQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SavedViewSidebarColumn">;
};
export type SavedViewUpdatesAsideQuery = {
  response: SavedViewUpdatesAsideQuery$data;
  variables: SavedViewUpdatesAsideQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewUuid"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUuid"
},
v2 = {
  "kind": "Variable",
  "name": "workspaceUuid",
  "variableName": "workspaceUuid"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "SavedViewUpdatesAsideQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "viewUuid",
            "variableName": "viewUuid"
          },
          (v2/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "SavedViewSidebarColumn"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SavedViewUpdatesAsideQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "uuid",
            "variableName": "viewUuid"
          },
          (v2/*: any*/)
        ],
        "concreteType": "DirectoryView",
        "kind": "LinkedField",
        "name": "directoryViewByUuid",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "uuid"
          },
          {
            "kind": "ScalarField",
            "name": "entityType"
          },
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "e5f55b435043b859c3f31205a1965cdc",
    "id": null,
    "metadata": {},
    "name": "SavedViewUpdatesAsideQuery",
    "operationKind": "query",
    "text": "query SavedViewUpdatesAsideQuery(\n  $workspaceUuid: UUID!\n  $viewUuid: UUID!\n) {\n  ...SavedViewSidebarColumn_3Na6m3\n}\n\nfragment SavedViewSidebarColumn_3Na6m3 on Query {\n  directoryViewByUuid(workspaceUuid: $workspaceUuid, uuid: $viewUuid) {\n    uuid\n    entityType\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "eae84978196627776ad4c0bd344eb087";

export default node;
